
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import Store from "@/store/Store";
import { IMasterData, MasterData } from "@/store/MasterData";
import ButtonVue from "@/lib/Button.vue";

import { Finder, IFinder } from "@/finder/IFinder";
import FinderVue from "@/finder/Finder.vue";

import { IOpOperacja } from "../../server/src/tree/mapper/op/IOp";
import {
  IOpKomponent,
  IOpEtapValidation,
} from "../../server/src/tree/mapper/op/IOp";
import { OpKomponent } from "../../server/src/tree/mapper/op/OpKomponent";
import { OpOperacja } from "../../server/src/tree/mapper/op/OpOperacja";
import DbgVue from "../Dbg.vue";
import { OpColor } from "server/src/tree/mapper/op/OpColor";
import { OpController } from "server/src/tree/mapper/op/OpController";
import { ITaskParent } from "server/src/task/ITaskParent";
import TasksVue from  "@/task/Tasks.vue";
const grps = require("../../server/src/grp/GrupyMaszynTs")
import { Debouncer } from "@/lib/Debouncer"

@Component({ components: { FinderVue, ButtonVue, DbgVue, TasksVue } })
export default class OpOperacjaVue extends Vue {
  @Prop(Object) operacja!: IOpOperacja;
  @Prop(String) file_path_lbl: any;
  @Prop(Object) oc: OpController | undefined;
  @Prop(Boolean) show_images!: Boolean;
  @Prop(Object) etap_validation!: IOpEtapValidation;
  @Prop(Number) etapy_validations_key!: number;
  @Prop(Number) lp!: number;
  debounced:any;

  md: IMasterData | undefined = undefined;
  komponent_finder = new Finder();
  key: number = 0;
  key_dbg: number = 0;
  dbg: number = 0;
  komponenty: IOpKomponent[] = [];
  color_preview_style: string = "";
  foreground_rgb: string = "";
  komponent_updated_text: string = "";
  rodzaje_farby: string[] = ["UV", "UV_LM", "LED_LM", "WODA"];
  rodzaje_lakieru: string[] = ["UV", "UV_LM", "LED_LM", "WODA"];
  operacje_typy: string[] = [];
  dd: string = "";
  grupy_maszyn = grps.grupy_maszyn_flekso;
  on_update_from_server_fired = false;


  watched: string[] = [
    "operacja.etap.grupa_maszyn",
    "operacja.etap.rodzaj_farby",
    "operacja.etap.rodzaj_lakieru",

    "operacja.zmiana",
    "operacja.color.pokrycie_procent",
    "operacja.procent_kosztow",
    "operacja.krotnosc",
    "operacja.newfoil_params.newfoil_x",
    "operacja.newfoil_params.newfoil_y",
    "operacja.newfoil_params.newfoil_z",
    "operacja.newfoil_params.newfoil_u",
    "operacja.newfoil_params.newfoil_koszt_płyki",
    "operacja.newfoil_params.newfoil_koszt_matrycypatrycy",
    "operacja.komponent_szerokosc",
    "operacja.komponent",
    "operacja.wydatek_sita_puchn",
    "operacja.color.drops"
  ];

  task_parent: ITaskParent | undefined;


  async mounted() {
    this.register(this.operacja)

    bus.register("masterdata_refresh", this.refresh_masterdata);
    
    this.debounced = Debouncer.debounce(await (this._chg.bind(this)), 1000).bind(this);
    for (let i = 0; i < this.watched.length; i++) {
      const prop = this.watched[i];
      this.$watch(prop, async (n, o) => {
        await this.debounced(prop, n, o);
      });
    }

    await this.refresh_masterdata();  }

  async mnt() {
    await this.refresh_masterdata();
  }


  async on_update_from_server(e:any) {

    if (e?.detail?._id == this.operacja._id) {
      console.log("on_update_from_server",e)
      if (e?.detail.komponent) {
      this.operacja.komponent = e?.detail.komponent
      }
      await this.mnt()
    }
  }



  register(op:IOpOperacja) {
    
    this.remove(this.operacja)
    console.log("bus.register komponent_selected" + op._id)
    bus.register("komponent_selected" + op._id,  this.komponent_selected)
    
  }
  remove(op:IOpOperacja) {
    bus.remove("komponent_selected" + op._id,  this.komponent_selected)
  }

  beforeDestroy() {
    this.remove(this.operacja)
    bus.remove("masterdata_refresh", this.refresh_masterdata);
  }

  async refresh_masterdata() {
    this.md = await (await new Store().getStore()).masterData;
    if (!this.md) return;

    if (!this.oc) return;
    if (!this.operacja) return;

    if (this.operacja.parent) {
      this.task_parent = { prj_id: this.operacja.parent.prj_id, prj_url:"", lbl_id: this.operacja.parent.lbl_id, lbl_url: "", op_id: this.operacja._id} 
    } else this.task_parent = undefined

    if (this.operacja.etap) {
      // pokaż jako etap; dalsza inicjalizacja niepotrzebna
      this.operacje_typy =
        this.md.typy_etapu_technologie[this.operacja.etap.etap_typ].technologie;
      this.key++;
      return;
    }
    if (!this.operacja.dbg) this.operacja.dbg={};
    if (!this.operacja.color) return;
    if (!this.operacja.color.etap_graflow) return;
    if (!this.operacja.color.technologia_graflow) return;
    if (this.operacja.color.rgb) {
      const r = this.operacja.color.rgb;
      if (r.length == 3) {
        this.color_preview_style =
          "background: rgb(" + r[0] + "," + r[1] + "," + r[2] + "); ";
        if (r[0] + r[1] + r[2] > 3 * 128)
          this.color_preview_style += "color: black;";
        else this.color_preview_style += "color: white;";
      }
    }

    const ett: string =
      this.operacja.color.etap_graflow +
      "@" +
      this.operacja.color.technologia_graflow;

    this.komponenty = this.md.komponenty_by_etech[ett];

    if (this.komponenty.length==1) {
      const f:any = this.komponenty[0]
      f.data=f
      f.filter=""
      this.operacja.komponent = this.finder_to_komponent(f as IFinder)
    }

    console.log(ett, this.md.komponenty_by_etech[ett])
    if (ett.includes("sito")) {
    for (const o of this.md.komponenty_by_etech[ett]) {
      console.log(o)
    }
    }
    this.komponent_finder = new Finder();

    if (this.operacja.komponent && this.operacja.komponent._id) {
      let komponent = this.get_komponent_by_id(
        this.operacja.komponent._id,
        this.komponenty
      );

      this.komponent_updated_text = "";
      if (komponent && komponent.text != this.operacja.komponent.text) {
        this.komponent_updated_text = komponent.text;
      }

      this.komponent_finder = this.komponent_to_finder(komponent);
      console.log("refresh_masterdata", this.komponent_finder)
    }

    this.key++;
  }

  get_komponent_by_id(
    id: any,
    kk: IOpKomponent[] | undefined
  ): IOpKomponent | undefined {
    if (!kk) return undefined;
    if (!id) return undefined;
    for (let i = 0; i < kk.length; i++) {
      let k = kk[i];
      if (k._id == id) {
        return k;
      }
    }
    return undefined;
  }
  komponent_to_finder(k: IOpKomponent | undefined): IFinder {
    let f = new Finder();
    if (!k) return f;
    if (!k._id) return f;
    f._id = k._id;
    f.text = k.text;
    return f;
  }

  finder_to_komponent(f: IFinder): IOpKomponent {
    const k = new OpKomponent();
    const d = f.data;
    if (!f) return k;
    if (!f._id) return k;

    k._id = f._id;
    k.text = f.text;

    (k.komponent_id = d.data_komponent_id),
      (k.komponent_typ = d.data_komponent_typ);
    k.komponent_nazwa = d.data_komponent_nazwa;
    k.komponent_exact = d.data_komponent_exact;
    k.komponent_exact_metry = d.data_komponent_exact_metry;
    k.komponent_kolor = d.data_komponent_kolor;
    k.komponent_polysk = d.data_komponent_polysk;
    k.komponent_podklad = d.data_komponent_podklad;
    k.komponent_grubosc_podkladu = d.data_komponent_grubosc_podkladu;
    k.komponent_cena = d.data_komponent_cena;
    k.komponent_jm = d.data_komponent_jm;
    k.komponent_lead_time = d.data_komponent_lead_time;
    k.komponent_wydatek = d.data_komponent_wydatek;

    return k;
  }

  async komponent_selected(e: any) {
    console.log("komponent_selected")
    let f: IFinder = e.detail;
    let k: IOpKomponent = this.finder_to_komponent(f);
    
    console.log("komponent_selected ",k?.text)
    if (!k) { alert("komponent is null");return; }
    if (!this.operacja.komponent) return;

    this.operacja.komponent = k;

/*
    let changed = 0;
    if (!this.operacja.komponent) {
      changed = 1;
    } else if (k && k._id != this.operacja.komponent._id) {
      changed = 1;
    }

    if (changed) {
      const k_old = this.operacja.komponent;
      this.operacja.komponent = k;
      //await this.changed('operacja.komponent',k, k_old)
    }
    */
  }

  async accept_komponent_update(f: Finder) {
    console.log("accept_komponent_update")
    const k_old = this.operacja.komponent;
    this.komponent_updated_text = "";
    let k: IOpKomponent = this.finder_to_komponent(f);
    this.operacja.komponent = k;
    // await this.changed('operacja.komponent',k, k_old)
  }

  async _chg(prop: string, n: any, o: any) {
    if (!this.oc) return;
    prop = prop.replace("operacja.", "");
    console.log("************ _chg ", prop, o, "=>", n);

    if (prop!='komponent') {
      await this.oc.update(this.operacja, prop, o, n);
    } else {
      console.log( o.komponent_id)
      console.log( n.komponent_id )
      if (!(o.komponent_id == n.komponent_id)) {
        await this.oc.update(this.operacja, prop, o, n);
        this.register(this.operacja) // version changed, needs update
      }
    }
  }

  async chg() {}

  async del_operacja(op: IOpOperacja) {
    await this.oc?.remove(op);
  }

async del_etap(op: IOpOperacja) {
    await this.oc?.remove_etap(op);
  }


  async move_operacja_up(op: IOpOperacja) {
    await this.oc?.move_up(op);
  }

  async move_operacja_down(op: IOpOperacja) {
    await this.oc?.move_down(op);
  }

  async add_operacja_to_etap(technologia_typ: string, etap_op: IOpOperacja) {
    if (!this.oc) return;
    const op = this.oc.create_operacja(technologia_typ, etap_op, "");
    await this.oc.add_operacja_to_etap(op, etap_op);
  }

  dbg_switch() {
    if (this.dbg) this.dbg = 0;
    else this.dbg = 1;
    this.key_dbg++;
  }

  selected_grupa_maszyn_valid(g:string, gg:string[]) {
    if (!g) return false;
    if (!g.trim()) return false;
    for (let g1 of gg) {
      if (g1==g) return true;
    }
    return false;
  }

  showDrops(op:any) {
    if (!op) return false;
    const nazwa=op?.color?.nazwa
    const kolor=op?.color?.kolor
    if (!kolor) return false;
    if (kolor.indexOf("MARK ANDY")==-1) return false;
    return true;
  }
}
